module.exports = __webpack_public_path__ + "resources/img/img_moai_main_func_m_en.a13def44dec270b7a9e4cb1d6d225fb6.png";